export default {
  home: {
    minute: "minute",
    price_info:
      "{mianfei) Minuten frei, maximum pro Tag {currencyNameftengding}, Pfand {currencyName} {yajin}, Kostenlose Mietkaution",
    submit: "Aufladen",
    borrow: "Ausleihen",
    msg_rentcount:
      "Sie haben derzeit {zujieNum) Bestellungen, die nicht abgeschlossen sind",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    msg_fail_title: "Fehler",
    msg_fail_content:
      "Die Miete ist fehlgeschlagen. Bitte versuchen Sie es erneut",
    offline:
      "Das Gerät {devicecode) ist offline, bitte wenden Sie sich an das anwesende Personal",
    permissionfail: "Zugriff verweigert.",
    unbound: "Mix QR code {devicecode) ist nicht an das Gerät gebunden",
    nobattery: "Kein Akku im Gerät verfügbar{devicecode}",
    next: "Weiter",
    renttext: "Akku leer? Kein Problem mehr, mit Anfy!"
  },
  loginborrow: {
    perhour: "pro Stunde",
    LANGUAGE: "SPRACHE",
    CreditCard: "Kreditkarte",
    perday: "pro Tag",
    max: "max",
    min: "Minuten",
    per: "pro",
    you_will_be_charged: "Ihnen werden berechnet",
    preauth: "Pfand",
    enterpromocode: "Geben Sie einen Aktionscode ein",
    powerbanktitle: "Schalten Sie die Anfy-Powerbank frei",
    msg_fail_title: "Fehler",
    msg_fail_user:
      "Fehler beim Abrufen der Benutzerinformationen. Möchten Sie es noch einmal versuchen?",
    msg_rentcount:
      "Sie haben derzeit {zujieNum} Bestellungen, die nicht abgeschlossen sind",
    msg_fail_support: "Das System wird nicht unterstützt",
    msg_fail_confirm: "Bestätigen",
    msg_fail_retry: "Wiederholen",
    msg_fail_cancel: "Abbrechen",
    msg_fail_order: "Mietauftrag konnte nicht erstellt werden",
    msg_fail_paymod: "Zahlungsmethode konnte nicht abgerufen werden",
    msg_fail_login: "Fehler bei der Anmeldung",
    Apple: "Apple",
    otheropt: "Andere Optionen",
    selectmethod: "Wählen Sie eine Zahlungsart",
    paymentdetail: "Details der Zahlungsart",
    couponcode: "Gutscheincode",
    rent: "Zahlung Bestätigen",
    pricing: "Preise anzeigen",
    phone: "Telefon",
    Google: "Google",
    Facebook: "Facebook",
    loginfb: "Mit Facebook anmelden",
    logingg: "Mit Google anmelden",
    captcha_code: "Code",
    phonenumber: "Telefonnummer eingeben",
    msg_fail_code: "Bitte den Bestätigungscode eingeben",
    msg_fail_phone: "Bitte geben sie ihre Telefonnummer ein",
    logout: "Konto verlassen",
    savenow: "Jetzt zahlen",
    delete: "Löschen",
    addcard: "Geben Sie die Kartendetails ein",
    msg_fail_content:
      "Die Miete ist fehlgeschlagen. Bitte versuchen Sie es erneut",
    title: "Bitte Bestätigen Sie die Autorisierung",
    policy: "Richtlinie.",
    term: "Geschäftsbedingungen",
    and: "und",
    privacy: "Datenschutzrichtlinie",
    tips: "Indem Sie fortfahren, Bestätigen Sie   unsere",
    cancel: "Abbrechen",
    agree: "Zustimmen",
    balance: "Guthaben"
  },
  preauth: {
    preauthortitle: "Über das Pfandsystem",
    tip1:
      "Bei Beginn einer Anmietung wird eine Vorautorisierung (Pfand) Ihrer Zahlungsmethode vorgenommen. Dies dient lediglich dazu, sicherzustellen, dass genügend Mittel zur Verfügung stehen, um Ihre Miete zu bezahlen.",
    tip2:
      "Ihre Bank sendet Ihnen möglicherweise eine Benachrichtigung, es wird jedoch keine Gebühr erhoben: Es wird nur der Preis Ihrer tatsächlichen Miete berechnet.",
    tip3:
      "Abhängig von Ihrer Bank kann es einige Stunden bis zu einigen Tagen dauern, bis der Betrag auf Ihren Kontoauszügen angepasst wird. Das ist normal."
  },
  rentcost: {
    rentcosttitle: "Wie viel kostet die Miete?",
    tip1:
      "Wenn Sie die Powerbank nicht innerhalb von 48 Stunden zurückgeben, wird Ihnen eine Nicht-Rückgabegebühr von {yajin} {currencyName} berechnet.",
    tip2:
      "Die Dauer wird auf die nächste halbe Stunde (30 oder 60 Minuten) gerundet.",
    tip3:
      "Die Miete für einen Tag beträgt 24 Stunden ab dem Zeitpunkt der Anmietung der Powerbank.",
    tip3_1:
      "Für Ihre Zahlungsmethode wird eine Pfandgebührin Höhe von{cyajin}{currencyName}erhoben. Damit soll sichergestellt werden, dass ausreichend Geld zur Verfügung steht, um Ihre Miete zu bezahlen.",
    tip3_2:
      "Ihre Bank sendet Ihnen möglicherweise eine Benachrichtigung, es fallen jedoch keine Gebühren an. Es wird nur der Preis Ihrer tatsächlichen Miete berechnet.",
    tip3_3:
      "Abhängig von Ihrer Bank kann es einige Stunden bis hin zu einigen Tagen dauern, bis der Betrag auf Ihren Kontoauszügen angepasst wird.",
    tip4: "Einige Standorte bieten möglicherweise Ermäßigungen.",
    Days: "Tage",
    Hours: "Stunden",
    Minutes: "Minuten"
  },
  logincode: {
    login: "Login",
    retry: "Erneutsenden",
    title: "Bestätigungscode",
    subtitle:
      "Bitte geben Sie den Bestätigungscode ein, den wiran Ihre Telefonnummer gesendet haben"
  },
  agreenconfirm: {
    title: "Bitte Bestätigen Sie die Autorisierung",
    policy: "Richtlinie.",
    term: "Allgemeine Geschäftsbedingungen von PowerBox",
    and: "und",
    privacy: "Datenschutzrichtlinie.",
    tips: "Ichstimmezu",
    cancel: "ABBRECHEN",
    agree: "ZUSTIMMEN"
  },
  login: {
    phonenumber: "Telefonnummer",
    verificationcode: "Bestätigungscode",
    Rentpowerbank: "Mieten Sie eine Powerbank",
    Rentpowerbanktip: "Geben Sie Ihre Handynummer ein, um zu beginnen",
    phone_number: "Bitte geben Sie eine{0}-stellige Mobil telefonnummer ein",
    captcha_code: "Code",
    send_code: "Codesenden",
    login: "Anmeldung",
    agree: "Indem Sie auf „Anmelden“ klicken, BestätigenSiedie",
    readme: `Nutzungsbedingungen`,
    msg_fail_login: "Fehler bei der Anmeldung",
    msg_success_login: "Anmeldung erfolgreich",
    msg_success_login_code:
      "Nacherfolgreichem Empfangladen Siebittedie Appherunter, umsichanzumelden",
    msg_fail_user:
      "Fehler beim Abrufen der Benutzerinformationen. WollenSieesnochmalversuchen?",
    no_sms: "Keine SMS erhalten",
    retry: "Erneut senden",
    receive: "Anwenden",
    invite_pwd: "Einladungscode",
    vip_agreen_tip: "Indem Sie fortfahren, akzeptieren Sieunsere",
    vip_agreen_service: "Nutzungsbedingungen",
    vip_agreen_and: "und",
    vip_agreen_policy: "Datenschutzrichtlinie"
  },
  confirm: {
    title: "Zahlungsbestätigung",
    pay_label: "Menge",
    addcard: "Kartehinzufügen",
    price_tips:
      "Indem Sie auf Bestätigenklicken, Bestätigen Siedie Zahlung unddie",
    price_btn: "„Mehrwertvereinbarung“",
    pay_type: "Bitte wählen Sie Ihre bevorzugte Zahlungsmethode aus",
    submit: "Mietvertrag Bestätigen",
    charge: "Bestätigen Siedas Aufladen",
    msg_fail_title: "Warnung",
    msg_fail_order: "Mietauftrag konnte nicht erstellt werden",
    msg_fail_confirm: "Bestätigen",
    msg_fail_retry: "Erneutversuchen",
    msg_fail_cancel: "Abbrechen"
  },
  mine: {
    title: "Nutzerprofil",
    wallet: "MeineWallet",
    balance: "Mein Guthaben",
    mywalletcard: "Meine Karte",
    addcard: "Wallet-Karte hinzufügen",
    deposit: "Pfand",
    wallet_in: "Aufladung",
    wallet_out: "Zurückziehen",
    wallet_log: "Wallet-Protokoll",
    order: "Bestellung",
    login_tips: "Bitte anmelden",
    msg_fail_title: "Fehler",
    msg_fail_user:
      "Fehler beim Abrufen der Benutzerinformationen. Möchten Sie es nochmal versuchen?",
    help: "Hilfe",
    setting: "Einstellung",
    logout: "Ausloggen",
    unpaid: "Unbezahlt",
    using: "In Benutzung"
  },
  msg: {
    oneOrdering:
      "1 Auftrag ist in Bearbeitung und der Mietvertrag kann vorerst nicht fortgeführt werden.",
    nopaymode: "Der Erwerb der Zahlungsmethode ist fehlgeschlagen",
    unlogin: "Sie sind noch nicht angemeldet, bitte melden Sie sich an",
    msg_fail_title: "Warnung",
    deletecard: "Möchten Sie diese Karte wirklich Löschen?",
    loading: "Wird geladen...",
    title: "Tipps",
    success: "Erfolgreiche Operation",
    error: "Unbekannter Fehler, bitte versuchen Sie es später noch einmal.",
    userinfo_fail:
      "Benutzerinformationen ungültig, bitte melden Sie sich erneut an",
    roleerror:
      "Unzureichende Berechtigungen, wenden Sie sich bitte an den Administrator",
    neterror:
      "Netzwerkverbindung fehlgeschlagen. Bitte versuchen Sie es später noch einmal",
    confirm: "Bestätigen",
    retry: "Wiederholen",
    cancel: "Abbrechen",
    msg_logout: "Möchten Sie das Konto wirklich verlassen?",
    vieworder: "Bestellung anzeigen",
    addorselectcard:
      "Bitte fügen Sie ein Kartenpaket hinzu oder wählen Sie ein Kartenpaket aus, um fortzufahren",
    success_payment: "Bezahlvorgang abgeschlossen",
    fail_payment: "Zahlungsfehler",
    keyword: "Stichwort",
    unpaid_order: "Es liegen unbezahlte Bestellungen vor",
    go_pay: "Bezahlen",
    no_more: "Keine weiteren",
    noshop: "keine Händler",
    msg_fail_code: "Bitte den Bestätigungscode eingeben",
    msg_fail_phone: "Bitte geben sie ihre Telefonnummer ein",
    msg_fail_orderid: "Bitte geben Sie die Bestellnummer ein",
    msg_fail_email: "E-Mail darf nicht leer sein",
    exceedorder:
      "Sie haben bereits eine Bestellung am laufen, bitte geben Sie diese zurück, bevor Sie fortfahren",
    nodevicecode: "Gerätecode existiert nicht",
    appoffline: "Die App wurde noch nicht gestartet. Bitte warten Sie",
    payment_unsupported: "Diese Zahlungsmethode wird nicht unterstützt",
    msg_fail_balance: "Unzureichendes Benutzerguthaben",
    msg_fail_order_balance:
      "Die Bestellung ist nicht vorhanden oder der Saldo reicht nicht aus"
  },
  result: {
    title: "Powerbank freigeschaltet!",
    tips: "Ihre Powerbank ist nun bereit zur Benutzung!",
    download: "Herunterladen",
    msg_result_loading: "Das Zahlungsergebnis wird bestätigt...",
    msg_tips_loading:
      "Der tragbare Akku taucht auf, bitte warten Sie geduldig ...",
    haveorder: "Der offizielle Auftrag wurde erstellt"
  },
  result_msg: {
    loading: "Wirdgeladen...",
    refresh: "Erneut laden"
  },
  order: {
    title: "Mietauftrag",
    in_use: "In Benutzung",
    ended: "Beendet",
    msg_error: "Anfrage fehlgeschlagen",
    no_data: "Keine Daten"
  },
  order_item: {
    order_number: "Nein.",
    venue_rented: "Ortder Mietung",
    time_rented: "Zeit gemietet",
    venue_returned: "Ort der Rückgabe",
    time_returned: "Zeitder Rückgabe",
    charge_standard: "Ladestandard",
    rent_occurred: "Mieteerfolgte",
    returned: "Zurückgegeben",
    unreturned: "Nichtzurückgegeben",
    type_0: "Nicht vollständig",
    type_1: "Vermietung",
    type_2: "Storniert",
    type_3: "Zurückgegeben",
    type_4: "Esistein Fehleraufgetreten",
    type_5: "Überzeit",
    min: "Min",
    unpaid: "Unbezahlt",
    payment: "Zahlung"
  }
};
